import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);
/* 多次点击当前路由报错 start */
// 获取原型对象上的 push 函数
const originalPush = Router.prototype.push;
// 修改原型对象中的 push 方法
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

const originalReplace = Router.prototype.replace;
// replace
Router.prototype.replace = function push(location, onResolve, onReject) {
    if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
    return originalReplace.call(this, location).catch(err => err)
}
/* 多次点击当前路由报错 end */
export default new Router({
    routes: [

        {
            path: "/",
            name: "login",
            component: () => import("@/view/index/index.vue"),
            meta: {
                title: "",
                hasTabBar: true,
                hasCustomer: true
            }
        },
        {
            path: "/application",
            name: "editorApplication",
            component: () => import("@/view/index/editorApplication.vue"),
            meta: {
                title: "编辑应用"
            }
        },
        {
            path: "/model",
            name: "model",
            component: () => import("@/view/mobile/index.vue"),
            meta: {
                title: "慧师 做有智慧的老师",

            }
        },
        {
            path: "/example",
            name: "example",
            component: () => import("@/view/index/example.vue"),
            meta: {
                title: "慧师 做有智慧的老师",

            }
        },
        {
            path: "/type",
            name: "SelectType",
            component: () => import("@/view/index/type.vue"),
            meta: {
                title: "选择类目",

            }
        },
        {
            path: "/result",
            name: "result",
            component: () => import("@/view/mobile/result.vue"),
            meta: {
                title: "",

            }
        },
        {
            path: "/use/record",
            name: "UseRecord",
            component: () => import("@/view/record/list.vue"),
            meta: {
                title: "使用记录",
                hasTabBar: true,
                hasCustomer: true
            }
        },
        {
            path: "/use/record/detail",
            name: "RecordDetail",
            component: () => import("@/view/record/detail.vue"),
            meta: {


            }
        },
        {
            path: "/my",
            name: "myIndex",
            component: () => import("@/view/my/index.vue"),
            meta: {
                title: '我的',
                hasTabBar: true,
                hasCustomer: true
            }
        },
        {
            path: "/myvip",
            name: "myVip",
            component: () => import("@/view/my/vip.vue"),
            meta: {
                title: "VIP会员中心",
            }
        },
        {
            path: "/my/invite",
            name: "myInvite",
            component: () => import("@/view/my/invite.vue"),
            meta: {
                title: "邀请好友",
            }
        },
        {
            path: "/my/account",
            name: "myAccount",
            component: () => import("@/view/my/account.vue"),
            meta: {
                title: "账号信息",
            }
        },
        {
            path: "/my/student",
            name: "myStudent",
            component: () => import("@/view/my/student.vue"),
            meta: {
                title: "我的学员",
            }
        },
        {
            path: "/my/student/detail",
            name: "myStudentDetail",
            component: () => import("@/view/my/student_detail.vue"),
            meta: {
                title: "学员详情",
            }
        },
        {
            path: "/zone",
            name: "zone",
            component: () => import("@/view/index/zone.vue"),
            meta: {
                title: "专区",
            }
        },
        {
            path: "/reward/details",
            name: "rewardDetails",
            component: () => import("@/view/my/rewardDetails.vue"),
            meta: {
                title: "奖励明细",
            }
        }
    ],

});



// WEBPACK FOOTER //
// ./src/router/index.js